import clsx from "classnames";
import moment from "moment";
import React, { useState } from "react";
import { DatePicker } from "@material-ui/pickers";
import { makeStyles, createStyles } from "@material-ui/core/styles";
import IconButton from "@material-ui/core/IconButton";

const format = (d, s) => moment.utc(d).format(s);
const isValid = d => moment.utc(d).isValid();
const isSameDay = (a, b) => moment.utc(a).isSame(moment.utc(b), "day");
const isWithinInterval = (a, { start, end }) =>
  moment.utc(a).isBetween(start, end);

const CustomElements = props => {
  const classes = useStyles();
  const formatWeekSelectLabel = (date, invalidLabel) => {
    if (!isValid(props.value)) return invalidLabel;
    if (!isValid(props.end)) return invalidLabel;
    if (isSameDay(props.value, props.end)) return format(props.value, "MMM D");
    return `${format(props.value, "MMM D")} - ${format(props.end, "MMM D")}`;
  };
  const renderWrappedWeekDay = (date, selectedDate, dayInCurrentMonth) => {
    const start = moment.utc(props.value);
    const end = moment.utc(props.end);
    const dateClone = moment(date).toDate();
    const dayIsBetween = isWithinInterval(dateClone, { start, end });
    const isFirstDay = isSameDay(dateClone, start);
    const isLastDay = isSameDay(dateClone, end);
    const wrapperClassName = clsx({
      [classes.highlight]: dayIsBetween,
      [classes.firstHighlight]: isFirstDay,
      [classes.endHighlight]: isLastDay
    });

    const dayClassName = clsx(classes.day, {
      [classes.nonCurrentMonthDay]: !dayInCurrentMonth,
      [classes.highlightNonCurrentMonthDay]: !dayInCurrentMonth && dayIsBetween
    });

    return (
      <div className={wrapperClassName}>
        <IconButton className={dayClassName}>
          <span> {format(dateClone, "D")} </span>
        </IconButton>
      </div>
    );
  };

  return (
    <DatePicker
      labelFunc={formatWeekSelectLabel}
      renderDay={renderWrappedWeekDay}
      {...props}
    />
  );
};

const useStyles = makeStyles(theme =>
  createStyles({
    dayWrapper: {
      position: "relative"
    },
    day: {
      width: 36,
      height: 36,
      fontSize: theme.typography.caption.fontSize,
      margin: "0 2px",
      color: "inherit"
    },
    customDayHighlight: {
      position: "absolute",
      top: 0,
      bottom: 0,
      left: "2px",
      right: "2px",
      border: `1px solid ${theme.palette.secondary.main}`,
      borderRadius: "50%"
    },
    nonCurrentMonthDay: {
      color: theme.palette.text.disabled
    },
    highlightNonCurrentMonthDay: {
      color: "#676767"
    },
    highlight: {
      background: theme.palette.primary.main,
      color: theme.palette.common.white
    },
    firstHighlight: {
      background: theme.palette.primary.main,
      color: theme.palette.common.white,
      borderTopLeftRadius: "50%",
      borderBottomLeftRadius: "50%"
    },
    endHighlight: {
      background: theme.palette.primary.main,
      color: theme.palette.common.white,
      borderTopRightRadius: "50%",
      borderBottomRightRadius: "50%"
    }
  })
);

export default CustomElements;
